import { render, staticRenderFns } from "./CaringForChildGa.vue?vue&type=template&id=2b372227&scoped=true"
import script from "./CaringForChildGa.vue?vue&type=script&lang=ts"
export * from "./CaringForChildGa.vue?vue&type=script&lang=ts"
import style0 from "./CaringForChildGa.vue?vue&type=style&index=0&id=2b372227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b372227",
  null
  
)

export default component.exports